/* eslint-disable no-bitwise */

interface UserRolesReduceVal {
  roleToCheck: number;
  userRoles: number[];
}

export const getUserRoles = (role: number) => {
  const binaryRole = (role >>> 0)
    .toString(2)
    .split('')
    .reverse();

  const initReduceAcc: UserRolesReduceVal = { roleToCheck: 1, userRoles: [] };

  return binaryRole.reduce((acc, binaryRoleVal) => {
    if (binaryRoleVal === '1') {
      return {
        userRoles: [...acc.userRoles, acc.roleToCheck],
        roleToCheck: acc.roleToCheck * 2
      };
    }

    return { ...acc, roleToCheck: acc.roleToCheck * 2 };
  }, initReduceAcc).userRoles;
};

export const isUserAllowed = (allowedRoles: number[], userRoles: number[]) => {
  if (allowedRoles) {
    return allowedRoles.some((r) => userRoles.indexOf(r) >= 0);
  }

  return true;
};

const determineUserRoles = (allowedRoles: number | number[]) => {
  if (typeof allowedRoles === 'number') {
    return getUserRoles(allowedRoles);
  }

  return allowedRoles;
};

export const isUserCombinedRoleAllowed = (
  allowedRoles: number | number[],
  userRole: number
) => {
  const userRoles = getUserRoles(userRole);

  const determinedAllowedRoles = determineUserRoles(allowedRoles);

  return isUserAllowed(determinedAllowedRoles, userRoles);
};
